import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";

const queryKey = (variables: Variables) => ["page", variables];

type Variables = {
  slug: string;
};

const usePageQuery = (
  { slug }: Variables,
  options?: { isEnabled?: boolean },
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey({ slug }),
    queryFn: () => api.getPage(slug),
    enabled: options?.isEnabled,
  });
};

export default usePageQuery;
